import { NavLink } from "react-router-dom";
import { Home, UtensilsCrossed, CalendarCheck, Music, User } from "lucide-react";

const items = [
  { to: "/", label: "Accueil", icon: Home },
  { to: "/la-carte", label: "La Carte", icon: UtensilsCrossed },
  { to: "/reserver", label: "Réserver", icon: CalendarCheck },
  { to: "/soirees", label: "Soirées", icon: Music },
  { to: "/profil", label: "Profil", icon: User },
];

export default function BottomNav() {
  return (
    <nav data-testid="bottom-nav" className="glass-bottom fixed bottom-0 left-0 right-0 z-50 md:hidden no-print">
      <div className="flex justify-around items-center h-16">
        {items.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={`bottomnav-${label.toLowerCase().replace("é", "e")}`}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 px-3 py-1 min-w-[44px] ${isActive ? "text-[#D4AF37]" : "text-gray-400"}`
            }
          >
            <Icon size={20} />
            <span className="text-[10px]">{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
